import React, { Component } from 'react'
//import {connect} from 'react-redux';
import Hero from "./hero/Hero";
import ChooseSpeed from "./choose-speed/ChooseSpeed";
import WifiOptions from "./wifi-options/WifiOptions";
import TopSites from "./top-sites/TopSites";
import Map from "./map/Map";
import SatisfactionGuaranteed from './satisfaction-guaranteed/SatisfactionGuaranteed';
import { setTitle, setMetaDescription } from '../../util';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: "",
      counterVal: 0,
      stickyLogo: false,
    };

    //this.imagesLoadedInterval = null;
    // this.loadComponent = this.loadComponent.bind(this);

  }
  componentDidMount() {
    document.querySelector('body').classList.add('bg--black');
    document.title = setTitle(this.props.title);
    setMetaDescription(this.props.description);
  }

  componentWillUnmount() {
    document.querySelector('body').classList.remove('bg--black');
  }
  setDeliveryDate()
  {

  }

  submit()
  {
    
  }
  render() {
    const { stickyContext, ...rest } = this.props;

    return (
      <div>
        <Hero stickyContext={stickyContext} />
        <ChooseSpeed />
        <WifiOptions />
        <TopSites />
        <Map {...rest} />
        <SatisfactionGuaranteed />
      </div>
    )
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/home/Home.js